import { Alert, Card, Empty, Skeleton } from 'antd';
import { useGetDistributionCost } from 'api/statistic/use-get-distribution-cost';
import { useGetDistributionCostByMonths } from 'api/statistic/use-get-distribution-cost-by-months';
import { useDistributionCostFiltersStore } from 'shared/stores/use-distribution-cost-filters';
import type { IDistributionCostFilter } from 'shared/stores/use-distribution-cost-filters';
import { DistributionCostAggregatedStatistic } from 'components/distribution-efficiency/distribution-cost-aggregated-statistic';
import { DistributionCostChart } from 'components/distribution-efficiency/distribution-cost-chart';
import { DistributionCostFilters } from 'components/distribution-efficiency/distribution-cost-filters';
import styles from './distribution-cost.module.scss';

export const DistributionCost = () => {
  const { filters } = useDistributionCostFiltersStore();

  const monthFilters: IDistributionCostFilter = {
    ...filters,
    date: [filters.date[0].startOf('month'), filters.date[1].endOf('month')],
  };

  const {
    data: totals,
    isFetching: isTotalsFetching,
    isError: isTotalsError,
  } = useGetDistributionCost({ filters: monthFilters });

  const {
    data: monthly,
    isFetching: isMonthlyFetching,
    isError: isMonthlyError,
  } = useGetDistributionCostByMonths({ filters: monthFilters });

  const series = monthly?.series;
  const isChartDataExists = series && (series.distributionCost.length > 0 || series.totalLdm.length > 0);
  const isFetching = isTotalsFetching || isMonthlyFetching;
  const isError = isTotalsError || isMonthlyError;

  return (
    <Card title='Distribution cost' className={styles.card}>
      <section className={styles.section}>
        <DistributionCostFilters />
        <Skeleton loading={isFetching}>
          {isError ? (
            <Alert type='error' message='Unable to load distribution cost statistics.' />
          ) : (
            <>
              {totals && (
                <DistributionCostAggregatedStatistic
                  distributionCost={totals.distributionCost}
                  totalLdm={totals.totalLdm}
                  costPerLdm={totals.costPerLdm}
                />
              )}
              {isChartDataExists ? (
                <DistributionCostChart title='Distribution cost by month' series={series} />
              ) : (
                <Empty description='No distribution cost data for this period' />
              )}
            </>
          )}
        </Skeleton>
      </section>
    </Card>
  );
};
